import { SystemField } from "./system-field";

export class ShiftSaleRev extends SystemField{
     
     category_id?:string;
     category_name?:string;
     amount?:number;
     staff_shifts_id?:string;
     transaction_date?:string;
     total_discount?:number;
}
